<div class="aca-admin aca-frm">
  <aca-page-header icon="dynamic_form" [title]="'DMS.FORMS.TITLE' | translate" [subtitle]="'DMS.FORMS.SUBTITLE' | translate">
    <button type="button" class="aca-frm__outline" (click)="reload()" [disabled]="loading()">
      <mat-icon>refresh</mat-icon>{{ 'DMS.FORMS.REFRESH' | translate }}
    </button>
    <button *ngIf="canDraft()" type="button" class="aca-frm__outline" (click)="draftWithAi()">
      <mat-icon>auto_awesome</mat-icon>{{ 'DMS.FORMS.DRAFT_BUTTON' | translate }}
    </button>
    <a *ngIf="isAdmin()" class="aca-frm__primary" routerLink="/forms/new"> <mat-icon>add</mat-icon>{{ 'DMS.FORMS.NEW' | translate }} </a>
  </aca-page-header>

  <p class="aca-frm__warn" *ngIf="!engineUp()" role="status"><mat-icon>warning_amber</mat-icon>{{ 'DMS.FORMS.ENGINE_DOWN' | translate }}</p>

  <div class="aca-frm__toolbar" *ngIf="all().length">
    <label class="aca-frm__search">
      <mat-icon>search</mat-icon>
      <input type="search" [placeholder]="'DMS.FORMS.SEARCH' | translate" [ngModel]="query()" (ngModelChange)="query.set($event)" />
    </label>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading()" />

  <aca-page-state
    *ngIf="failed()"
    state="error"
    [title]="'DMS.FORMS.LOAD_FAILED' | translate"
    [message]="failed()"
    [actionLabel]="'DMS.FORMS.REFRESH' | translate"
    (action)="reload()"
  />

  <ng-container *ngIf="!loading() && !failed()">
    <!-- ── forms to fill in ─────────────────────────────────────────────── -->
    <h2 class="aca-frm__heading">{{ 'DMS.FORMS.TO_FILL' | translate }}</h2>
    <aca-page-state
      *ngIf="!published().length"
      state="empty"
      icon="dynamic_form"
      [title]="'DMS.FORMS.NONE_PUBLISHED' | translate"
      [message]="(isAdmin() ? 'DMS.FORMS.NONE_PUBLISHED_ADMIN' : 'DMS.FORMS.NONE_PUBLISHED_USER') | translate"
    />
    <div class="aca-frm__cards" *ngIf="published().length">
      <a class="aca-frm__card" *ngFor="let form of published()" [routerLink]="['/forms', form.id]">
        <span class="aca-frm__cardicon"><mat-icon>description</mat-icon></span>
        <span class="aca-frm__cardbody">
          <span class="aca-frm__cardtitle">{{ form.title }}</span>
          <span class="aca-frm__carddesc" *ngIf="form.description">{{ form.description }}</span>
          <span class="aca-frm__cardmeta">
            <span *ngIf="form.code" class="aca-frm__code">{{ form.code }}</span>
            {{ 'DMS.FORMS.FIELDS' | translate: { count: fieldCount(form) } }} · {{ 'DMS.FORMS.VERSION' | translate: { version: form.version } }}
          </span>
        </span>
        <span class="aca-frm__cardgo">{{ 'DMS.FORMS.FILL' | translate }}<mat-icon>arrow_forward</mat-icon></span>
      </a>
    </div>

    <!-- ── administration ───────────────────────────────────────────────── -->
    <ng-container *ngIf="isAdmin() && managed().length">
      <h2 class="aca-frm__heading">{{ 'DMS.FORMS.MANAGE' | translate }}</h2>
      <div class="aca-frm__tablewrap">
        <table class="aca-frm__table">
          <thead>
            <tr>
              <th>{{ 'DMS.FORMS.COL_FORM' | translate }}</th>
              <th>{{ 'DMS.FORMS.COL_STATUS' | translate }}</th>
              <th>{{ 'DMS.FORMS.COL_VERSION' | translate }}</th>
              <th>{{ 'DMS.FORMS.COL_SUBMISSIONS' | translate }}</th>
              <th>{{ 'DMS.FORMS.COL_UPDATED' | translate }}</th>
              <th class="aca-frm__actionscol">
                <span class="aca-sr-only">{{ 'DMS.FORMS.COL_ACTIONS' | translate }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let form of managed()" [class.aca-frm__row--busy]="busy() === form.id">
              <td>
                <a class="aca-frm__name" [routerLink]="['/forms', form.id, 'edit']">{{ form.title || ('DMS.FORMS.UNTITLED' | translate) }}</a>
                <span class="aca-frm__sub"
                  >{{ form.code }}{{ form.code ? ' · ' : '' }}{{ 'DMS.FORMS.FIELDS' | translate: { count: fieldCount(form) } }}</span
                >
              </td>
              <td>
                <span class="aca-frm__chip aca-frm__chip--{{ form.status }}">{{ 'DMS.FORMS.STATUS_' + form.status.toUpperCase() | translate }}</span>
              </td>
              <td>{{ form.version }}</td>
              <td>
                <a class="aca-frm__count" [routerLink]="['/forms', form.id, 'submissions']" [matTooltip]="'DMS.FORMS.REPORT_OPEN' | translate">
                  <mat-icon>table_view</mat-icon>{{ counts()[form.id!] || 0 }}
                </a>
              </td>
              <td>
                <span *ngIf="form.updatedAt">{{ form.updatedAt | acaDate: 'd MMM y HH:mm' }}</span>
                <span class="aca-frm__sub" *ngIf="form.updatedBy">{{ form.updatedBy }}</span>
              </td>
              <td class="aca-frm__actions">
                <a class="aca-frm__icon" [routerLink]="['/forms', form.id, 'edit']" [matTooltip]="'DMS.FORMS.EDIT' | translate">
                  <mat-icon>edit</mat-icon><span class="aca-sr-only">{{ 'DMS.FORMS.EDIT' | translate }}</span>
                </a>
                <button
                  type="button"
                  class="aca-frm__icon"
                  *ngIf="form.status !== 'published'"
                  [disabled]="!!busy()"
                  (click)="setStatus(form, 'published')"
                  [matTooltip]="'DMS.FORMS.PUBLISH' | translate"
                  [attr.aria-label]="'DMS.FORMS.PUBLISH' | translate"
                >
                  <mat-icon>publish</mat-icon>
                </button>
                <button
                  type="button"
                  class="aca-frm__icon"
                  *ngIf="form.status === 'published'"
                  [disabled]="!!busy()"
                  (click)="setStatus(form, 'archived')"
                  [matTooltip]="'DMS.FORMS.ARCHIVE' | translate"
                  [attr.aria-label]="'DMS.FORMS.ARCHIVE' | translate"
                >
                  <mat-icon>archive</mat-icon>
                </button>
                <button
                  type="button"
                  class="aca-frm__icon"
                  [disabled]="!!busy()"
                  (click)="duplicate(form)"
                  [matTooltip]="'DMS.FORMS.DUPLICATE' | translate"
                  [attr.aria-label]="'DMS.FORMS.DUPLICATE' | translate"
                >
                  <mat-icon>content_copy</mat-icon>
                </button>
                <!-- a form that was ever published may have filed PDFs naming it: archive those instead -->
                <button
                  type="button"
                  class="aca-frm__icon aca-frm__icon--danger"
                  *ngIf="!form.publishedAt"
                  [disabled]="!!busy()"
                  (click)="remove(form)"
                  [matTooltip]="'DMS.FORMS.DELETE' | translate"
                  [attr.aria-label]="'DMS.FORMS.DELETE' | translate"
                >
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ng-container>
</div>
